export enum UniversalI18nNamespace {
  Common = 'common',
}
